import React from 'react'
import { Modal, Form, Input, Button, Row, Col, Pagination, message } from 'antd'
import { Link } from 'react-router-dom'
import { DeleteOutlined } from '@ant-design/icons'
import { AddTag } from '../../index'
import * as API from '../../../api'
import './index.less'
import { getContentType } from '../../../utils/global'
export type ContentSelectTypeValue = 'btn' | 'block' ;
export interface ContentProps {
	url: string; // 内容链接
	thumb: string; // 内容缩略图
}

export interface ContentSelectState {
	contentList: ContentProps[];
	checkList: ContentSelectInfoType[];
	initialValues: object;
	queryBody: object;
	is_not_work: object;
	queryShould: object;
	idMap: object;
	pageTotal?: number;
	modalVisible: boolean;
	delVisidle: boolean;
	nameList: string[];
}

export interface ContentSelectInfoType {
  id: string;
	st_fileurl: string;
	st_text_title: string;
}

type CheckIdList = ContentSelectInfoType[];

interface CheckListProps {
	value?: ContentSelectInfoType;
	onChange?: (value: CheckIdList) => void;
  type?: ContentSelectTypeValue; // 按钮弹框或者块级区域展示
  nameList?: string[];
	rowNum?: number; // 每行展示的个数 每页的个数为3倍
}
class ContentSelect extends React.Component<CheckListProps, ContentSelectState> {
	static defaultProps = {
		type: 'btn',
		rowNum: 3,
	}

	state: ContentSelectState = {
		nameList: this.props.nameList || [],
		contentList: [],
		checkList: [],
		delVisidle: false,
		initialValues: {
			id: '',
			st_create_work_id: '',
			st_text_title: '',
		},
		queryBody: { // 查询body
			query:{
				bool: {
					filter: [{
						bool: {
							filter: {
								term: {
									is_del: '0'
								}
							}
						}
					}]
				}
			},
			sort: [
				{
					st_update_time: {
						order: 'DESC'
					}
				},
				{
					st_create_time: {
						order: 'DESC'
					}
				}
			],
			pageNo: '1',
			size: this.props.rowNum * 3,
		},
		is_not_work: {
			bool: {
				filter: {
					term: {
						st_is_works: '0'
					}
				}
			}
		},
		queryShould: {}, // 形式查询条件
		modalVisible: false,
		idMap: {}
	}

	handleModalVisible (val: boolean) {
		this.setState({
			modalVisible: val
		})
		if(val) {
			this.init()
		}
	}
	componentDidMount() {
		if(this.props.type === 'block') this.init()
	}

	componentDidUpdate(prevProps) {
		if(prevProps.value !== this.props.value) {
			const value = this.props.value
			this.setState({
				checkList: Object.prototype.toString.call(value) === '[object Array]' ? value : [value]
			})
		}
	}
	async init() {
		const { nameList } = this.state
		const nameMap = await getContentType('nameMap')
		const idMap = await getContentType('idMap')
		const query = {bool: {should: []}}
		if(nameList.length > 0) {
			// 传入的内容形式 或的关系 生成
			nameList.forEach(item => {
				query.bool.should.push({bool: {filter: {term: {st_type: nameMap[item]}}}})
			})
		}
		this.setState({
			queryShould: query,
			idMap
		},() => {
			this.getContentList()
		})
	}
	onSearch = () => {
		// 搜索 处理 filterList
		const { initialValues } = this.state
		const filter = []
		// 创建除标签以外的搜索对象
		Object.keys(initialValues).forEach(key => {
			if(initialValues[key] !== '') {
				const data = {}
				data['bool'] = {}
				data['bool']['filter'] = {}
				data['bool']['filter'][key === 'st_text_title' ? 'match' : 'term'] = {}
				data['bool']['filter'][key === 'st_text_title' ? 'match' : 'term'][key] = initialValues[key]
				filter.push(data)
			}
		})
		console.log('filter', filter)
		// 获取标签搜索对象
		const condition = this.refs.addTagRef.getConditionList()

		if(JSON.stringify(condition) !== '{}') {
			filter.push(condition)
		}
		filter.push({
			bool: {
				filter: {
					term: {
						is_del: '0'
					}
				}
			}
		})
		const query = {
			bool: {
				filter: filter
			}
		}
		this.getContentList(filter.length > 0 ? query : '')
	}
	async getContentList (params?) {
		// console.log('params',params)
		const { queryBody, is_not_work, queryShould } = this.state
		let body = {}
		if(params) {
			queryBody.query = params
		}
		// 传入的内容形式 加入搜索条件
		if(JSON.stringify(queryShould) !== '{}') {
			queryBody.query.bool.filter.push(queryShould)
		}
		// 不是作品
		queryBody.query.bool.filter.push(is_not_work)
		body = queryBody
		// console.log('body', body)
		const res = await API.getContentList(body)
		if(res.code === 0) {
			const { list, count } = res.data
			this.setState({
				contentList: list,
				queryBody: body,
				pageTotal: count,
			})
			const value = this.props.value
			if(value && value.length > 0) {
				this.onCheck(this,this.props.value)
			}
		}
	}
	onReset = () => {
		const initialValues =  {
			st_text_title: '',
			id: '',
			st_create_work_id: ''
		}

		this.refs.addTagRef.reset()
		this.refs.form.setFieldsValue(initialValues)
		this.setState({
			initialValues
		}, () => {
			this.onSearch()
		})
	}

	onCheck = (e: React.MouseEvent, val: object) => {
		const contentList = this.state.contentList
		contentList.forEach((item: object) => {
			item['isCheck'] = false
			if(item.id === val.id) {
				item.isCheck = true
			}
		})
		const checkList = []
		checkList.push(val)
		console.log('onCheck checkList',checkList)
		this.setState({
			checkList,
			contentList
		})
	}

	handleConfirm = () => {
		const { checkList } = this.state
		if(checkList.length === 0) return
		const list: CheckIdList = []
		checkList.forEach(item => {
			if(item.st_fileurl && item.id) {
				list.push({
					id: item.id,
					st_fileurl: item.st_fileurl,
					st_text_title: item.st_text_title
				})
			} else {
				message.error('内容没有st_fileurl，请选择其他内容')
			}
		})
		console.log('handleConfirm checkList', this.state.checkList)
		this.triggerChange(list)
		this.handleModalVisible(false)
	}
	triggerChange = (checkList: CheckIdList): void => {
		const { onChange } = this.props
		console.log('triggerChange checkList', checkList)
		onChange && onChange(checkList)
	}
	delSelectItem = () => {
		const { onChange } = this.props
		this.setState({contentList: []})
		onChange && onChange([])
	}

	render() {
		const { contentList, modalVisible, initialValues, queryBody, pageTotal, idMap, checkList, delVisidle } = this.state
		const onFinish = (values: object) => {
			console.log('onFinish', values)
			this.setState({
				initialValues: values
			}, () => {
				this.onSearch()
			})
		}
		const onFinishFailed = (errorInfo: object) => {
			console.log('Failed:', errorInfo)
		}
		const onChangePage = (page: number) => {
			const { queryBody } = this.state
			queryBody['pageNo'] = page
			this.setState({
				queryBody
			},() => {
				this.getContentList()
			})
		}
		const handleShowDel = (val) => {
			this.setState({delVisidle: val})
		}
		const selectItemShowNode = () => {

			const isImage = checkList.length > 0 ? /\.(gif|jpg|jpeg|png|GIF|JPEG|JPG|PNG)$/.test(checkList[0].st_fileurl) : false
			return (
				checkList.length > 0 ? isImage ?
					<div className={delVisidle ? 'select-item-imgwrap hover' : 'select-item-imgwrap'} onMouseEnter={ () => handleShowDel(true)} onMouseLeave={() => handleShowDel(false)}>
						<DeleteOutlined
							onClick={this.delSelectItem.bind(this)}
							style={{
								fontSize: '14px',
								color: '#333',
								backgroundColor: '#fff',
								width: '22px',
								height: '22px',
								textAlign: 'center',
								lineHeight: '26px',
								borderRadius: '50%'
							}}
						/>
						<img src={checkList[0].st_fileurl} alt={checkList[0].st_text_title}/>
					</div>
					:
					<span className="file-title">{checkList.length > 0 && checkList[0].st_text_title}</span>
					:
					<Button type="primary" onClick={this.handleModalVisible.bind(this, true)}>
						内容库
					</Button>
			)
		}
		const sizeChange = (val, size) => {
			const { queryBody } = this.state
			queryBody.size = size
			this.setState({
				queryBody
			}, () => {
				this.getContentList()
			})
		}
		const renderContentSelectBlock = () => {
			return (<>
				<Form
					className="search-bar"
					layout="inline"
					ref="form"
					onFinish={onFinish}
					onFinishFailed={onFinishFailed}
					initialValues={initialValues}
					colon={false}
				>
					<Form.Item
						label="ID"
						name="id"
						className="label-id"
					>
						<Input/>
					</Form.Item>
					<Form.Item
						label="标题"
						name="st_text_title"
					>
						<Input/>
					</Form.Item>
					<Form.Item
						label="创建者"
						name="st_create_work">
						<Input/>
					</Form.Item>
					<div className="condition-wrap">
						<AddTag ref="addTagRef"/>
						<Button className="fl" type="primary" htmlType="submit" style={{marginRight: '10px'}}>搜索</Button>
						<Button className="fl" onClick={this.onReset}>重置</Button>
					</div>
				</Form>

				<Row className="content-select-wrap clearfix" gutter={[10, 10]}>
					{contentList.length
						? <>
							{contentList.map(content => (
								<Col span={(24 / this.props.rowNum).toFixed()} key={content['id']}>
									<div className="content-box" onClick={(e) => {this.onCheck(e, content)}}>
										<span className={content && content['isCheck'] ? 'ant-radio ant-radio-checked' : 'ant-radio'}>
											<i className="ant-radio-inner"></i>
										</span>
										<div className="title">{content['st_text_title']}</div>
										<img src={idMap[content['st_type']] === '图片' ? content['st_fileurl'] : idMap[content['st_type']] === '音频' ? 'http://m.elongstatic.com/cdc/com-static/music.png' : content['st_thumbnail'] ? content['st_thumbnail'] : 'http://m.elongstatic.com/cdc/com-static/video.png'} alt={content['st_text_title']}/>
									</div>
								</Col>
							))}
						</>

						: <p className="empty">
							<span>暂无素材，请前往内容库添加</span>
							<Button type="link">
								<Link to="/main/content/library/index">选择文件上传</Link>
							</Button>
						</p>
					}
				</Row>
				{/* 分页 */}
				{contentList.length > 0
					?
					<Pagination
						onChange={onChangePage}
						onShowSizeChange={sizeChange}
						defaultPageSize={queryBody['size']}
						size="small"
						total={pageTotal}
					/>
					: ''
				}
			</>)
		}
		return this.props.type === 'btn' ? (
			<div>
				{selectItemShowNode()}
				<Modal
					className="content-select-box"
					title="内容库"
					visible={modalVisible}
					onCancel={this.handleModalVisible.bind(this,false)}
					footer={[
						<Button key="confirm" type="primary" onClick={this.handleConfirm}>确定使用</Button>
					]}
				>
					{renderContentSelectBlock()}
				</Modal>
			</div>
		) : (
			<div className="content-select-box">
				{renderContentSelectBlock()}
				<Button style={{ marginTop: '10px' }} className="confirm-btn" key="confirm" type="primary" onClick={this.handleConfirm}>确定使用</Button>
			</div>
		)
	}
}

export default ContentSelect